module.exports['xdiff_string_diff'] = require('./xdiff_string_diff')
module.exports['xdiff_string_patch'] = require('./xdiff_string_patch')
